import { Link } from "react-router-dom";
import type { Character } from "@/types/content";

export default function CharacterCard({ character }: { character: Character }) {
  return (
    <Link
      to={`/detail/character/${character.id}`}
      className="group block rounded-lg overflow-hidden border border-background-200 bg-background-50 cursor-pointer transition-colors hover:border-accent-400"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={character.avatar}
          alt={`${character.name} 角色形象`}
          title={`${character.name} - 继母的诱惑 角色解析`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-primary-950/85 to-transparent" />
        <span className="absolute top-3 left-3 rounded-md bg-background-50/90 text-primary-700 text-xs px-2.5 py-1">
          {character.type}
        </span>
        <div className="absolute inset-x-0 bottom-0 p-4">
          <h3 className="font-heading text-lg font-semibold text-background-50">
            {character.name}
          </h3>
          <p className="mt-1 text-xs text-background-200/90 line-clamp-1">{character.identity}</p>
        </div>
      </div>
      <div className="p-4">
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
          {character.intro}
        </p>
        <span className="mt-3 inline-flex items-center gap-1 text-xs text-secondary-700 bg-secondary-100 rounded-full px-2.5 py-1">
          <i className="ri-group-line" />
          {character.camp}
        </span>
      </div>
    </Link>
  );
}